function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback, FC, MutableRefObject, EventHandler } from 'react';
import cn from 'classnames';
import { Icon } from '../../../components/Icon';
import { IconNameMedium, IconNameSmall } from '../../../components/Icon/icons';
require("./AddonAfter.css");
var styles = {
  "Root": "AddonAfter-module-Root_24v",
  "Icon": "AddonAfter-module-Icon_198"
};
export const AddonAfter = ({
  className,
  collapseIconName = 'chevronUp',
  expandIconName = 'chevronDown',
  inputRef,
  isExpanded = false,
  onPointerDown,
  ...rest
}) => {
  const handlePointerDown = useCallback(e => {
    if (inputRef.current && typeof window !== 'undefined') {
      window.requestAnimationFrame(() => inputRef.current.focus());
    }
    onPointerDown(e);
  }, [inputRef, onPointerDown]);
  return /*#__PURE__*/React.createElement("button", _extends({
    className: styles.Root,
    "aria-label": isExpanded ? 'Меню открыто' : 'Меню закрыто',
    onPointerDown: handlePointerDown
  }, rest), /*#__PURE__*/React.createElement(Icon, {
    name: isExpanded ? collapseIconName : expandIconName,
    "aria-hidden": "true",
    size: "m",
    className: cn(styles.Icon, className)
  }));
};